export const TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME = "twentyPointInspected"
export const twentyPointInspectedDefault = false

const sN = TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME
const dV = twentyPointInspectedDefault

export const TWENTY_POINT_INSPECTED_FILTER_CONFIG = {
  short_name: sN,
  default_values: dV,
  is_default: value => testTwentyPointInspectedDefault(value), //right before clean up
  format_to_api: value => formatTwentyPointInspectedForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatTwentyPointInspectedFromURL(value) //
}

export const formatTwentyPointInspectedFromURL = value => {
  if (typeof value === 'boolean') {
    return value
  }

  return value === 'true' ? true : false
}

export const testTwentyPointInspectedDefault = value => {
  if (value !== twentyPointInspectedDefault) {
    return false
  }
  return true
}

//api
export const formatTwentyPointInspectedForAPI = value => {
  if (value) {
    return {
      twenty_point_inspected: value
    }
  } else {
    return {}
  }
}